import ScrollLoader from 'vue-scroll-loader'
import Vue from "vue";

Vue.use(ScrollLoader)
